import instance from '../../api'

const BASE_ENDPOINT = '/api/admin/adjustments'

export const createBalanceAdjustment = (form) => instance.post(BASE_ENDPOINT, { ...form })
